import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import Select from 'react-select'
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
import $ from "jquery";
import addbutton from "../static/images/add-button.png";
import xbutton from "../static/images/X_icon.png";
import { sortObjectArray } from "../utils/Sort";

const Habilidades = ({ data, edit }) => {
  const [loading, setLoading] = useState(true);
  const [listSkils, setlistSkils] = useState([]);
  const [userSkillsList, setuserSkillsList] = useState([]);
  const [delSkill, setdelSkill] = useState("");
  //const [allowAction, setallowAction] = useState(true);

  useEffect(() => {
    if (data === undefined) {
      setLoading(true);
    } else {
      GetUserSkills();
    }
  }, [data]);

  useEffect(() => {
    if (data === undefined) {
      setLoading(true);
    } else {
      GetListSkills();
    }
  }, [userSkillsList]);

  function ConvertArray(list) {
    let array = [];

    list.map((item) => {
      if (!userSkillsList.find((i) => i.skillId === item.skillId)) {

        let op = {
          value: item.skillId,
          name: item.name,
        };
        array.push(op);
      }
    });
    setlistSkils(array);
    setLoading(false);
  }

  function GetUserSkills() {
    axios.get("skills/list-skills-applicant/" + data).then((result) => {
      setuserSkillsList(result.data);
    });
  }

  function GetListSkills() {

    axios.get("skills/list-skills").then((result) => {
      ConvertArray(result.data);
    });
  }

  function FindSkill(id) {
    setdelSkill(userSkillsList.find((i) => i.skillId === id));
  }

  function DeleteSkill() {
    // const mod = new Modal(document.getElementById("eliminar-habilidad-modal"));

    let skil = {
      applicantId: data,
      applicantSkillId: delSkill.skillApplicantId,
      skillId: delSkill.skillId,
    };

    axios
      .post("skills/delete-applicantskill", skil)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          //mod.hide();
          GetUserSkills();
          $("#eliminar-habilidad-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#eliminar-habilidad-modal").modal("hide");
      });
  }

  function GuardarSkills(values) {

    const exp = {
      applicantId: data,
      applicantSkillId: 0,
      skillId: values.slSkills,
    };

    axios
      .post("skills/create-applicantskill", exp)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetUserSkills();
          $("#agregar-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#agregar-modal").modal("hide");
      });
  }

  const Validaciones = Yup.object().shape({
    slSkills: Yup.string().required("No puede estar vacio"),
  });

  return (
    <Fragment>
      <div className="box left-col">
        <div className="head">
          <div className="title">Habilidades</div>
          {edit ? (
            <a href="#" data-bs-toggle="modal" data-bs-target="#agregar-modal">
              <img src={addbutton} alt="Agregar Experiencia"></img>
            </a>
          ) : (
            ""
          )}
        </div>
        {loading ? (
          <label className="login-label">CARGANDO</label>
        ) : (
          <div className="tags-cloud">
            <div className="tags-cloud__wrapper">
              {userSkillsList.map((item, index) => {
                return (
                  <div>
                    {edit ? (
                      <div key={index} className="tag">
                        <span
                          className="cierre-X"
                          data-bs-toggle="modal"
                          data-bs-target="#eliminar-habilidad-modal"
                          onClick={() => FindSkill(item.skillId)}
                        >
                          <img src={xbutton} style={{ width: "20px" }}></img>
                        </span>
                        {item.name}
                      </div>
                    ) : (
                      <div key={index} className="tag">
                        {item.name}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <div
        id="agregar-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <Formik
                  initialValues={{
                    slSkills: 0,
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    GuardarSkills(values);
                    setSubmitting(false);
                  }}
                  validationSchema={Validaciones}
                >
                  {({ errors, touched, isSubmitting, setFieldValue }) => (
                    <Form>
                      <div className="div__wrapper">
                        <div className="form__title text-center">
                          Habilidades
                        </div>
                        <div className="form__row">
                          <div className="col-sm-12">
                            <label htmlFor="position">Habilidad</label>
                            
                            <Select 
                              options={sortObjectArray(listSkils, "name").map(e => ({
                                value: e.value,
                                label: e.name
                              }))}
                              name="slSkills"
                              onChange={({value}) => setFieldValue("slSkills", value)}
                              noOptionsMessage={() => "sin resultados"}
                              placeholder="Seleccione una habilidad"
                            />

                            {errors.slSkills && touched.slSkills && (
                              <span className="form__validation form__validation--error">
                                {errors.slSkills}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="form__row">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--gradient btn__icon btn__icon--door"
                          >
                            <i className="fas fa-paper-plane"></i>Aceptar
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="eliminar-habilidad-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Eliminar Habilidad
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeleteSkill()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Habilidades;
